<template>
    <div class="header header-fix">
        <div class="bot">
            <div id="tsa-pc-navigation"></div>
        </div>
    </div>
</template>

<script>
import 'tsa-components-umd/dist/tsa-components-umd.min.css'
const TsaComponentsUmd = require('tsa-components-umd')
export default {
    name: 'tsa-header',
    data() {
        return {
        };
    },
    components: {},
    computed: {
    },
    created() {
    },
    mounted() {
        this.$nextTick(() => {
            TsaComponentsUmd.pcNavigation({
                type: 'share',
                el: '#tsa-pc-navigation',
                clientId: "",
                logoHref: process.env.VUE_APP_TSAPLUS,
                env: process.env.VUE_APP_ENV,
                internationalization: false,
                currentPath: 'https://sharing.tsa.cn',
                logo: "https://tsa-content.oss-cn-beijing.aliyuncs.com/logo/timestamp_whole_dark_logo.png",
                title: "可信时间戳知识产权保护平台",
                seoTitle: "可信时间戳知识产权保护平台",
            })
        })
    },
    methods: {
    
    }
};
</script>

<style lang="less" scoped>
.header{
    background-color: #fff;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10003;
    width: 100%;
    min-width: 1280PX;
    text-align: center;
    *{
        box-sizing: content-box;
        font-family: 'PingFang SC-Medium','PingFang SC','苹方',"微软雅黑", "Arial","sans-serif","Helvetica", "宋体";
    }
}
</style>
